const onlyDigitsPattern = /\D/g;
const combiningMarksPattern = /[\u0300-\u036f]/g;
export function digitsOnly(value) {
    return value.replace(onlyDigitsPattern, '');
}
export function isNumericSearchInput(value) {
    return /^[\d\s().+-]+$/.test(value.trim());
}
export function normalizeBrazilianSearchDigits(value) {
    const digits = digitsOnly(value);
    if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
        return digits.slice(2);
    }
    return digits;
}
export function isCompletePatientDigitSearch(value) {
    if (!isNumericSearchInput(value))
        return false;
    const digits = normalizeBrazilianSearchDigits(value);
    return digits.length === 10 || digits.length === 11;
}
export function normalizeSearchText(value) {
    return value
        .normalize('NFD')
        .replace(combiningMarksPattern, '')
        .toLocaleLowerCase('pt-BR')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
export function isValidCpf(value) {
    const cpf = digitsOnly(value);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf))
        return false;
    const calculateDigit = (length) => {
        let sum = 0;
        for (let index = 0; index < length; index += 1) {
            sum += Number(cpf[index]) * (length + 1 - index);
        }
        const remainder = (sum * 10) % 11;
        return remainder === 10 ? 0 : remainder;
    };
    return calculateDigit(9) === Number(cpf[9]) && calculateDigit(10) === Number(cpf[10]);
}
export function isValidCep(value) {
    return /^\d{8}$/.test(digitsOnly(value));
}
export function isValidBrazilianPhone(value) {
    const phone = digitsOnly(value);
    return phone.length === 10 || phone.length === 11;
}
export function formatCpf(value) {
    return digitsOnly(value)
        .slice(0, 11)
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
}
export function formatCep(value) {
    return digitsOnly(value)
        .slice(0, 8)
        .replace(/^(\d{5})(\d)/, '$1-$2');
}
export function formatPhone(value) {
    const phone = digitsOnly(value).slice(0, 11);
    if (phone.length <= 10) {
        return phone.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
    }
    return phone.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
}
export function toWhatsAppUrl(value) {
    const phone = digitsOnly(value);
    if (!isValidBrazilianPhone(phone))
        return null;
    return `https://wa.me/55${phone}`;
}
//# sourceMappingURL=normalization.js.map